export default "__VITE_ASSET__CqslSLtn__"